import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { INITIAL_STEP } from '~/components/organisms/stepper/constants';
import { QRCODE_STATIC_STEP, QRCODE_STATUS } from '~/constants/qr-code';
import { PATH } from '~/constants/route-path';
import { useAppDispatch } from '~/hooks/useRedux';
import { stepperSlice } from '~/store/reducers/stepepr';
import useBuilderStore from '~/store/useBuilderStore';

export const useStaticQrStylesHandleClickStep = ({ qrId, mutationFn, qrStaticType, qrCodeStatus }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const stepperActions = stepperSlice.actions;

  const moveToDoneStatusMutation = useMutation({ mutationFn });

  const { setActiveStep } = useBuilderStore();

  const finishEditing = () => {
    navigate(PATH.QR.MAIN);
    dispatch(stepperActions.setRedirectRoute(''));
    setActiveStep(INITIAL_STEP);
  };

  const moveQrCodeToDoneStatus = () => {
    if (qrCodeStatus === QRCODE_STATUS.DONE) {
      finishEditing();
      return;
    }

    moveToDoneStatusMutation.mutate({ id: qrId, body: { status: QRCODE_STATUS.DONE } }, { onSuccess: finishEditing });
  };

  const handleClickStep = async (step) => {
    if (step === 0) navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.TYPE, qrStaticType, qrId));
    if (step === 1) navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.CONTENT, qrStaticType, qrId));
    if (step === 3) moveQrCodeToDoneStatus();
  };

  return {
    handleClickStep,
    isProcessing: moveToDoneStatusMutation.isPending,
  };
};
